<template>
    <div style="padding: 10px 10px 10px 0;page-break-before: auto;page-break-after: always;">
        <el-dialog :visible.sync="show" width="700px" id="printTest" :before-close="handleClose">
            <div ref="print" style="margin-top:0px;padding: 0;">
                <div
                    style="border-top: 1px solid #000000;border-bottom: 1px solid #000000;text-align: center;font-size: 24px;padding: 5px 0;">
                    缴款通知书</div>
                <div>
                    商品名称: {{ obj.shopName }}
                </div>
                <div>经营品牌: {{ obj.shopName }}</div>
                <div style="display: flex;justify-content: space-between;border-bottom: 1px solid #000000;">
                    <div>商铺编号: {{ obj.shopNum }}</div>
                    <div>合同号: {{ obj.number }}</div>
                </div>
                <div>尊敬的供应商:</div>
                <div style="margin: 5px 0;">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;根据贵我双方租赁合同中的有关条款约定，请贵司按期将下列款项汇至本公司账户。
                </div>
                <div>户名: 江苏国际人才咨询服务有限公司</div>
                <div style="margin: 5px 0;">开 户 银 行: 中国银行江苏省分行营业部</div>
                <div>账号: 5092 6897 8348</div>
                <div style="margin:20px 0 0 30px;">
                    <div>谢谢合作!</div>
                    <el-button v-if="isDyxs" type="primary" size="mini" @click="addShopPay()">新增</el-button>

                </div>
                <el-table :data="bdShopPayList" style="width: 100%" border>
                    <el-table-column prop="type" label="款项类别"></el-table-column>
                    <el-table-column prop="term" label="所属期限">
                    </el-table-column>
                    <el-table-column prop="appdate" label="最后缴款日">
                        <template slot-scope="{row}">
                            {{ row.appdate.split("T")[0] }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="money" label="应交金额(元)">
                        <template slot-scope="scope">
                            <span v-if="scope.row.editIs == '0'">
                                {{ scope.row.money }}
                            </span>
                            <el-input v-else v-model="scope.row.money" placeholder="请输入金额"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注"></el-table-column>
                    <el-table-column v-if="isDyxs" class="no-print" width="80" prop="remark" label="操作">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.editIs == '0'" type="primary" size="mini"
                                @click="editShopPay(scope.row, scope.$index)">修改</el-button>
                            <el-button v-else type="primary" size="mini"
                                @click="saveShopPay(scope.row, scope.$index)">保存</el-button>

                        </template>
                    </el-table-column>
                </el-table>
                <!-- 	<div style="margin: 0 0 5px 10px;">备注:提成租金:第1年5%扣点。</div> -->
                <div style="margin: 0 0 0 15px;">电费:1元/度: 水费:按公共事业公布标准+10%的管理费</div>
                <div style="margin: 0 0 0 15px;">合计:{{ sum }}元</div>
                <div style="text-align: right;margin-top: 50px;">江苏国际人才咨询服务有限公司</div>
                <div style="text-align: right;">{{ new Date().getFullYear() }}年{{ new Date().getMonth() + 1 }}月{{
                    new
                                    Date().getDate()
                }}日</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="show = false; isDyxs = true;">关 闭</el-button>
                <el-button plain @click="aaa" type="primary">打 印</el-button>
            </span>
        </el-dialog>

        <el-dialog title="修改" :visible.sync="isChange" width="30%">
            <el-form :model="form">
                <el-form-item label="缴费状态">
                    <el-select v-model="status" placeholder="状态" style="width: 100px;">
                        <el-option label="已缴费" value="已缴费"></el-option>
                        <el-option label="未缴费" value="未缴费"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isChange = false">关 闭</el-button>
                <el-button @click="isOk" type="primary">确 定</el-button>
            </span>
        </el-dialog>
        <el-form :inline="true" :model="form" class="demo-form-inline">
            <div class="flex sb">
                <div>
                    <el-form-item label="商铺号">
                        <el-input size="small" v-model="form.shopNum" placeholder="商铺号" style="width: 150px;"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商铺名称">
                        <el-input size="small" v-model="form.shopName" placeholder="商铺名称" style="width: 150px;"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="联系人">
                        <el-input size="small" v-model="form.name" placeholder="联系人" clearable
                            style="width: 150px;"></el-input>
                    </el-form-item>
                    <el-form-item label="联系方式">
                        <el-input size="small" v-model="form.phone" placeholder="手机号" clearable
                            style="width: 150px;"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="缴费状态">
                        <el-select v-model="form.status" placeholder="状态" style="width: 100px;">
                            <el-option label="已缴费" value="已缴费"></el-option>
                            <el-option label="未缴费" value="未缴费"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <!-- <el-form-item label="提醒状态">
                        <el-select v-model="form.remind" placeholder="提醒状态" clearable style="width: 150px;">
                            <el-option label="已提醒" value="已提醒"></el-option>
                            <el-option label="未提醒" value="未提醒"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item>
                        <el-button size="small" type="primary" @click="query">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-popover placement="bottom" width="180" v-model="show2" style="margin-bottom: 20px;">
                            <el-checkbox-group v-model="checkList" @change="checkChange">
                                <el-checkbox :label="val" v-for="(val, key) in oldTitleObj" :key="key"
                                    :disabled="val == oneRow">
                                </el-checkbox>
                            </el-checkbox-group>
                            <el-button size="small" slot="reference" type="primary">筛选列表</el-button>
                        </el-popover>
                    </el-form-item>

                    <el-form-item>
                        <!-- <el-button type="primary" @click="dc">导出</el-button> -->
                    </el-form-item>
                </div>

            </div>
        </el-form>
        <el-table :data="data" style="width: 100%" v-loading="loading">
            <el-table-column v-for="(val, key, index) in titleObj" :prop="key" :label="val" align="center"
                v-if="key != `is`">
            </el-table-column>
            <el-table-column prop="status" label="缴费状态">
                <template slot-scope="{row}">
                    <span
                        :style="(row.status == '已缴费' && row.wuyeStatus == '1' && row.promotionStatus == '1') ? 'color:#30C25B' : 'color:red'">
                        {{ (row.status == '已缴费' && row.wuyeStatus == '1' && row.promotionStatus == '1') ? '已缴费' :
    '未缴费'
                        }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="remind" label="提醒状态"></el-table-column> -->
            <el-table-column prop="date" label="操作">
                <template slot-scope="{row}">
                    <el-button type="text" @click="lookRow(row)">查看</el-button>
                    <!-- <el-button type="text" @click="changeRow(row)">修改</el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <el-pagination :page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" @size-change="handleSizeChange"
        :current-page="selectForm.currentPage"
            @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="count">
        </el-pagination>
    </div>
</template>

<script>
import publicExport from '../../../assets/js/publicExport.js';
import downloadFile from '../../../assets/js/downloadFile.js';
import { setTimeout } from 'timers';
export default {
    data() {
        return {
            loading: false,
            sum: 0,
            count: 0,
            isDyxs: true,
            users: [], //申请人
            show: false,
            status: '',
            id: '',
            bdShopPayList: [],
            form: {
                "applyId": "", //申请人id
                "phone": "", //联系电话
                "result": "", //状态
                "shopName": "", //商铺名称
                "shopNum": "", //商铺号
                "type": "", //类型（正常，违规）
                "currentPage": 1,
                "pageSize": 10,
            },
            addForm: {},
            data: [],
            obj: {
                fileRes: "",
                applyTime: ""
            }, //详情数据
            isChange: false,
            show2: false, //控制筛选列的多选框
            oneRow: "", //当checkList列表只有一项时,选择框不可点击
            checkList: ["商铺号", "商铺名称", "联系人", "联系方式", "账单日期"
                , "租金", "租金增值税9%", "租金收入", "物业费", "物业增值税6%",
                "物业费收入", "推广费", "推广增值税6%", "推广费收入", "购电费", "水费", "应缴合计"],
            titleObj: {
                shopNum: "商铺号",
                shopName: "商铺名称",
                name: "联系人",
                phone: '联系方式',
                appdate: '账单日期',
                money: "租金",
                rentalRevenue: "租金增值税9%",
                rentalIncome: "租金收入",
                wuyepay: "物业费",
                wuyeRevenue: "物业增值税6%",
                wuyeIncome: "物业费收入",
                promotionSum: "推广费",
                promotionRevenue: "推广增值税6%",
                promotionIncome: "推广费收入",
                electricPay: "购电费",
                waterPay: "水费",
                total: "应缴合计",
            },
            oldTitleObj: {
                shopNum: "商铺号",
                shopName: "商铺名称",
                name: "联系人",
                phone: '联系方式',
                appdate: '账单日期',
                money: "租金",
                rentalRevenue: "租金增值税9%",
                rentalIncome: "租金收入",
                wuyepay: "物业费",
                wuyeRevenue: "物业增值税6%",
                wuyeIncome: "物业费收入",
                promotionSum: "推广费",
                promotionRevenue: "推广增值税6%",
                promotionIncome: "推广费收入",
                electricPay: "购电费",
                waterPay: "水费",
                total: "应缴合计",
            },
            roleId: "",
        }
    },
    created() {
        this.roleId = localStorage.roleId

        this.getAll();
        this.getUsers();
    },
    methods: {
        query() {
            this.selectForm.currentPage = 1;
            this.getAll();
        },
        editShopPay(row, index) {
            this.bdShopPayList[index].editIs = "1";
        },
        saveShopPay(row, index) {
            if (row.money === '') {
                this.$message.error("请输入金额")
                return;
            }
            let data = {
                list: [
                    {
                        money: row.money,
                        type: row.type
                    }
                ],
                shopNum: this.obj.shopNum,
                time: row.appdate,
            }
            this.$http.post("/api/safe/shopPay/update", data).then(res => {
                if (res.data.code == 0) {
                    this.$message.success(res.data.data)
                    this.bdShopPayList[index].editIs = "0";
                    this.getAll();
                } else {
                    this.$message.error(res.data.data)
                }

            })

        },
        aaa() {
            // if (1 == 1) {
            //     this.$message.error("水电费为空，无法打印！")
            //     return false;
            // }
            this.isDyxs = false;
            setTimeout(r => {
                this.$print(this.$refs.print)
            }, 1000)

        },
        checkChange(val) { //筛选列复选框被改变
            console.log(val)
            // val.forEach(val=>{
            // 	if(val=='')
            // })
            var newObj = {}
            for (var key in this.oldTitleObj) {
                if (val.indexOf(this.oldTitleObj[key]) != -1) {
                    newObj[key] = this.oldTitleObj[key]
                }
            }
            this.titleObj = newObj;
            if (val.length == 1) { //只有一列时,复选框禁止勾选
                this.oneRow = val[0];
                this.$message.warning("表格内容至少显示一列")
                return;
            }
            this.oneRow = ""
        },

        handleClose() {
            this.show = false
            this.isDyxs = true
        },
        downFil(item) {
            downloadFile(item)
        },
        changeRow(obj) {
            this.id = obj.id
            this.status = obj.status
            this.isChange = true
        },
        isOk() {
            this.$http.post("/api/shopPay/updateShopPay", {
                id: this.id,
                status: this.status
            }).then(res => {
                if (res.data.code == 0) {
                    this.$message.success(res.data.message)
                    this.isChange = false
                    this.getAll()
                }
                console.log(res)

            })
        },
        lookRow(obj) {
            this.sum = 0;
            this.$http.get(`/api/safe/shopPay/selectOne?id=${obj.id}`).then(res => {
                if (res.data.code == 0) {
                    this.obj = res.data.data
                    res.data.data.bdShopPayList.forEach(val => {
                        val.editIs = "0"
                        this.sum = Math.floor(val.money * 100) / 100 + this.sum
                    })
                    this.bdShopPayList = JSON.parse(JSON.stringify(res.data.data.bdShopPayList))
                    this.show = true;
                } else {
                    this.$message.error("查询失败！")
                }
            })
        },
        handleCurrentChange(val) {
            this.form.currentPage = val;
            this.getAll()
        },
        handleSizeChange(val) {
            this.form.pageSize = val;
            this.getAll()
        },
        dc() {
            publicExport("/api/shopPay/exportShopPay", this.form, "费用收缴")
        },
        getUsers() { //查询申请人
            this.$http.get("/api/bdShopRenovation/getUserShop").then(res => {
                this.users = res.data.data
            })
        },
        getAll() { //获取表格数据
            this.loading = true;
            this.$http.post("/api/safe/shopPay/queryShopPay", this.form).then(res => {
                this.loading = false;
                if (res.data.code == 0) {
                    this.count = res.data.data.totalNum;
                    this.data = res.data.data.items
                } else {
                    this.data = [];
                    this.count = 0
                }

            })
        },

    },

}
</script>

<style scoped="scoped">
.box {
    font-size: 16px;
    width: 70%;
}

.box>div {
    margin-bottom: 10px;
}
</style>
